export const USERS_ENDPOINT = `https://jsonplaceholder.typicode.com/users`;

export const TODOS_ENDPOINT = `https://jsonplaceholder.typicode.com/todos`;
